export default "__VITE_PUBLIC_ASSET__9b555c3c__"